import Swal from "sweetalert2"

export const handleRecategorizeAction = async ({
  sg,
  itemSku,
  newType,
  action_search_osrm_action,
  putUpdateInfoOrderAction,
  onSuccess,
}: {
  sg: any
  itemSku: string
  newType: string
  action_search_osrm_action: (entity: string, body: any) => Promise<any>
  putUpdateInfoOrderAction: (id: string, body: any) => Promise<any>
  onSuccess: () => void
}) => {
  try {
    const confirmResult = await Swal.fire({
      title: "¿Estás seguro?",
      text: "¿Deseas recategorizar este ítem?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#007AFF",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, recategorizar",
      cancelButtonText: "Cancelar",
    })

    if (!confirmResult.isConfirmed) {
      return
    }

    Swal.fire({
      title: "Recategorizando...",
      text: "Por favor espere mientras se actualiza la información.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    // 1. Fetch the Order
    const orderRes = await action_search_osrm_action("orders", {
      from: 0,
      size: 1,
      filters: { id: sg.orderId },
    })

    const order = orderRes?.data?.message?.records?.[0]
    if (!order) {
      throw new Error("No se pudo encontrar la orden asociada.")
    }

    // 2. Update Order's logisticPlan
    // Order structure: { logisticPlan: { sources: [ { items: [ { sku, type } ] } ] } }
    let orderLogisticPlan = JSON.parse(JSON.stringify(order.logisticPlan || {}))
    let orderUpdated = false

    if (orderLogisticPlan.sources && Array.isArray(orderLogisticPlan.sources)) {
      orderLogisticPlan.sources.forEach((source: any) => {
        if (source.items && Array.isArray(source.items)) {
          source.items.forEach((item: any) => {
            if (item.sku === itemSku) {
              item.type = newType
              orderUpdated = true
            }
          })
        }
      })
    }

    if (!orderUpdated) {
      throw new Error("No se encontró el ítem en la orden.")
    }

    // 3. Update ShippingGroup's logisticPlan
    // SG structure: { logisticPlan: { items: [ { sku, type } ] } }
    let sgLogisticPlan = JSON.parse(JSON.stringify(sg.logisticPlan || {}))
    let sgUpdated = false

    if (sgLogisticPlan.items && Array.isArray(sgLogisticPlan.items)) {
      sgLogisticPlan.items.forEach((item: any) => {
        if (item.sku === itemSku) {
          item.type = newType
          sgUpdated = true
        }
      })
    }

    if (!sgUpdated) {
      throw new Error("No se encontró el ítem en la orden de envío (SG).")
    }

    // 4. Send updates
    // SG update
    await putUpdateInfoOrderAction(sg.id, {
      entityType: "ShippingGroup",
      entityId: sg.id,
      data: {
        logisticPlan: sgLogisticPlan,
      },
    })

    // Order update
    await putUpdateInfoOrderAction(order.id, {
      entityType: "Order",
      entityId: order.id,
      data: {
        logisticPlan: orderLogisticPlan,
      },
    })

    Swal.fire({
      title: "Éxito",
      text: "La recategorización se ha completado correctamente.",
      icon: "success",
    })

    if (onSuccess) {
      onSuccess()
    }
  } catch (error: any) {
    Swal.fire({
      title: "Error",
      text: error?.message || "Ocurrió un error inesperado al recategorizar.",
      icon: "error",
    })
  }
}
